import React from "react";
import type { UserListItem } from "types/domain";

const getInitials = (name?: string | null) =>
  (name ?? "?")
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join("") || "?";

interface ParticipantUserAvatarProps {
  user: UserListItem;
  size?: "sm" | "md";
}

const ParticipantUserAvatar = ({
  user,
  size = "sm",
}: ParticipantUserAvatarProps): JSX.Element => {
  const sizeClass = size === "md" ? "h-12 w-12 text-sm" : "h-10 w-10 text-xs";

  if (user.avatar_url) {
    return (
      <img
        src={user.avatar_url}
        alt={user.full_name}
        className={`${sizeClass} rounded-full object-cover`}
      />
    );
  }

  return (
    <div
      className={`${sizeClass} flex items-center justify-center rounded-full bg-brand-50 font-semibold text-brand-600 dark:bg-brand-500/15 dark:text-brand-300`}
    >
      {getInitials(user.full_name)}
    </div>
  );
};

export default ParticipantUserAvatar;